module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKZJREFUKFONjzEOwjAQBO+tfIAHUNwDUOyHRJQ0FPCPVPRIqQhxUMiyPoOEY4LwaJWTPFnbAoEoCjYqKnFPkjCgJ45fh5CUdSYADVHsEGfLQ1eZcCZbXBm8j+kz4UIUe/s7LU6fQksqNlQ2taXQEcWB6YxCCMTZS4JRCCNRHJnRmAm14dngX3M9b0j3Pi2/Ii6PO/ND+KPhttQwYCKpYTKGXPhO3HsC04aIacv7+JYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/package-x-generic.png
// module id = b/nY
// module chunks = 1